import type { StatusBadgeProps } from "@/components/ds/StatusBadge";
import { MessageSquare, Phone, FlaskConical, type LucideIcon } from "lucide-react";
type Tone = NonNullable<StatusBadgeProps["tone"]>;

export const STATUS_META: Record<string, { label: string; tone: Tone }> = {
  open: { label: "Open", tone: "blue" },
  waiting_customer: { label: "Waiting for Customer", tone: "amber" },
  waiting_staff: { label: "Waiting for Staff", tone: "amber" },
  appointment_booked: { label: "Appointment Booked", tone: "green" },
  escalated: { label: "Escalated", tone: "red" },
  resolved: { label: "Resolved", tone: "slate" },
  spam: { label: "Spam", tone: "slate" },
};

export const CHANNEL_META: Record<string, { label: string; icon: LucideIcon }> = {
  sms: { label: "SMS", icon: MessageSquare },
  voice: { label: "Voice", icon: Phone },
  simulator: { label: "Simulator", icon: FlaskConical },
};

// How each thread item is rendered — strict separation of authorship.
export const KIND_META: Record<string, { label: string; tone: Tone }> = {
  customer_message: { label: "Customer", tone: "slate" },
  ai_reply: { label: "AI", tone: "blue" },
  staff_reply: { label: "Staff", tone: "green" },
  internal_note: { label: "Internal note", tone: "amber" },
  system_event: { label: "System", tone: "slate" },
  ai_action: { label: "AI action", tone: "blue" },
  appointment_event: { label: "Appointment", tone: "green" },
};

export function fmtTime(iso?: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}
export function fmtDuration(secs?: number | null): string {
  if (!secs) return "—";
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return `${m}m ${s}s`;
}
